import {Injectable, TemplateRef} from '@angular/core';
import {DbDateStruct} from './date-struct';

/**
 * A configuration service for the [`DbDatepicker`](#/components/datepicker/api#NgbDatepicker) component.
 *
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the datepickers used in the application.
 */
@Injectable({providedIn: 'root'})
export class DbDatepickerConfig {
  footerTemplate: TemplateRef<any>;
  displayMonths = 1;
  firstDayOfWeek = 0;
  markDisabled: (date: DbDateStruct, current?: {year: number, month: number}) => boolean;
  minDate: DbDateStruct;
  maxDate: DbDateStruct;
  outsideDays: 'visible' | 'collapsed' | 'hidden' = 'visible';
  showWeekNumbers = false;
  startDate: {year: number, month: number};
  endDate: null;
  canSelectRange: false;
  selectOnClick: false;
}
